import React from 'react';
import {Helmet} from 'react-helmet';
import {sprintf} from 'sprintf-js';
import locales from '../../locales/locales';
import Navbar from '../navbar/navbar';
import Footer from '../footer/footer';
const TermsOfService=({globalSettings})=>{
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {locales.tosTitle[globalSettings.lang]}</title>
      </Helmet>
      <Navbar globalSettings={globalSettings} />
      <div className='flex-1 bg-purple-50 pt-16'>
        <div className='max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24'>
          <div className='text-center mb-10'>
            <h1 className='text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight'>
              {locales.tosHeadingPrefix[globalSettings.lang]}
              <span className='text-purple-800'>
                {locales.tosHeadingHighlight[globalSettings.lang]}
              </span>
              {locales.tosHeadingSuffix[globalSettings.lang]}
            </h1>
          </div>
          <div className='bg-white p-8 rounded-xl shadow-lg border border-gray-200'>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosIntroTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosIntroContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosScopeTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosScopeContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosObligationsTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosObligationsContent1[globalSettings.lang]}
              </p>
              <p className='text-gray-600 mb-4'>
                {locales.tosObligationsContent2[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosSubscriptionTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosSubscriptionContent1[globalSettings.lang]}
              </p>
              <p className='text-gray-600 mb-4'>
                {locales.tosSubscriptionContent2[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosLiabilityTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosLiabilityContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosTerminationTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosTerminationContent1[globalSettings.lang]}
              </p>
              <p className='text-gray-600 mb-4'>
                {locales.tosTerminationContent2[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosAmendmentsTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosAmendmentsContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosLanguageTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosLanguageContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosContactTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {sprintf(
                  locales.tosContactContent[globalSettings.lang],
                  'legal@nekotranslate.ai',
                )}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.tosMiscTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.tosMiscContent[globalSettings.lang]}
              </p>
            </div>
          </div>
          <div className='mt-8 text-center'>
            <p className='text-gray-600'>
              {locales.tosLastUpdated[globalSettings.lang]}
            </p>
          </div>
        </div>
      </div>
      <Footer globalSettings={globalSettings} />
    </div>
  );
};
export default TermsOfService;

